// extracted by mini-css-extract-plugin
module.exports = {"Prose":"Prose_Prose__2zaJW","customColor":"Prose_customColor__2UHCQ","inverse":"Prose_inverse__3gfXV"};